module.exports = __webpack_public_path__ + "img/banner-digital-protection.79aff7d9.jpeg";